import { useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { BedSvg, CalendarIconSvg, MoonIconSvg, InfoIconSvg, UserIconSvg } from "../../assets/svg";
import { splitDate } from "../../utils/splitDate";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import ViewDetailsModal from "../../components/Modals/ViewDetailModal/ViewDetailModal";
import dayjs from "dayjs";

const LeadsTableRow = ({item,fetchData}:any) => {
  const[show,setShow]= useState(false)
  return (
    <>
    <div className="min-h-[171px] my-3 border rounded bg-light">
      <Row className="bg-[#F9FFF2] border-bottom rounded-top min-h-[34px] m-0 justify-content-between align-items-center " style={{ fontSize: "16px", fontWeight: "700" }}>
        <Col><p className="m-0">{item?.routename}</p></Col>
        <Col className="d-flex justify-content-end align-items-center">
          <p className="px-2 m-0 text-[#92278F]">{item?.number}</p>
          <p className={`px-2 m-0 text-${item?.status === "ACTIVE" ? 'success' : item?.status === "SHARED" || item?.status === "PARTIAL_PAID" ? 'warning' : 'danger'}`}>STATUS : {item?.status === "SHARED" ? "Quotation Shared" : item?.status?.replace('_', ' ')}</p>
        </Col>
      </Row>
      <Row className="justify-content-between m-0 mt-4 text-[#7A7A7A]" style={{ fontSize: "17px", fontWeight: "500" }}>
        <Col xs={4} className="d-flex align-items-center">
          <CalendarIconSvg height={19} width={19} fill="#7a7a7a"/>
          <p className="mx-1 my-auto">  {dayjs(splitDate(item?.starttime)).format("DD MMM YYYY")} - {dayjs(splitDate(item?.endtime)).format("DD MMM YYYY")}</p>
        </Col>
        <Col className="d-flex align-items-center">
          <MoonIconSvg fill="#7a7a7a"/>
          <p className="mx-1 my-auto">{item?.nights} Nights</p></Col>
        <Col className="d-flex align-items-center">
          <UserIconSvg fill="#7a7a7a"/>
          <p className="mx-1 my-auto">{(Number(item?.infants) || 0) + (Number(item?.children) || 0) + (Number(item?.adults) || 0)} Guests</p>
          <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
            overlay={
              <Tooltip>
                  {`Adult: ${item?.adults || 0}`}
                  <br />
                  {`Children: ${item?.children || 0}`}
                  <br />
                  {`Infant: ${item?.infants || 0}`}
              </Tooltip>
            }>
            <span className="cursor-pointer">
              <InfoIconSvg fill="#D0566E" />
            </span>
          </OverlayTrigger>
        </Col>
        <Col className="d-flex align-items-center">
          <BedSvg fill="#7a7a7a"/>
          <p className="mx-1 my-auto">{item?.room_count} {item?.room_count > 1 ? 'Cabins' : 'Cabin'}</p>
          <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
            overlay={
              <Tooltip>
                  {item?.cabin_categories && item?.cabin_categories.map((cabin: any) => <>{cabin}<br/></>)}
              </Tooltip>
            }>
            <span className="cursor-pointer">
              <InfoIconSvg fill="#D0566E" />
            </span>
          </OverlayTrigger>
        </Col>
        <Col className="d-flex align-items-center justify-content-end mx-2">
          <button className="border p-1 rounded bg-[#EEEEEE] text-nowrap my-auto text-[#3A3A3A]" style={{ fontSize: "14px", fontWeight: "400" }} onClick={()=>{setShow(true)}}>
            View Details
          </button>
        </Col>

      </Row>
      <Row className="text-[#7A7A7A] mx-0 mt-3 justify-content-between" style={{ fontSize: "14px", lineHeight: "18.23px" }}>
        <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Full Name</p>
          <p className="m-o" style={{ fontWeight: "700" }}>{item?.customer?.first_name} {item?.customer?.last_name}</p>
        </Col>
        <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Phone Number</p>
          <p className="m-o" style={{ fontWeight: "700" }}>{item?.customer?.phone_number}</p>
        </Col>
        <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Email</p>
          <p className="m-o" style={{ fontWeight: "700" }}>{item?.customer?.email}</p>
        </Col>
        {/* <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Address</p>
          <p className="m-o" style={{ fontWeight: "700" }}>32/B, Gurudweshar</p>
        </Col> */}
        <Col>
        </Col>
      </Row>
    </div>
       <ModalWrapper show={show} handleClose={()=>{
        fetchData()
        setShow(false)
        }} clx={'view-detail-modal-wrapper max-h-[90vh]'}>
       <ViewDetailsModal quotationDetail={item?.id} />
     </ModalWrapper>
     </>
  )
}
export default LeadsTableRow